"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _NewTab = _interopRequireDefault(require("@paprika/icon/lib/NewTab"));

var constants = _interopRequireWildcard(require("@paprika/constants/lib/Constants"));

var types = _interopRequireWildcard(require("../../types"));

var sc = _interopRequireWildcard(require("./LinkButton.styles"));

var _Button = require("../../Button");

var Link = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var a11yText = props.a11yText,
      children = props.children,
      href = props.href,
      isDisabled = props.isDisabled,
      shouldOpenNewTab = props.shouldOpenNewTab,
      kind = props.kind,
      icon = props.icon,
      size = props.size,
      suffixIcon = props.suffixIcon,
      moreProps = (0, _objectWithoutProperties2["default"])(props, ["a11yText", "children", "href", "isDisabled", "shouldOpenNewTab", "kind", "icon", "size", "suffixIcon"]);
  var shouldOpenNewTabProps = {
    target: "_blank",
    rel: "noopener noreferrer"
  };

  function renderSuffix(_ref) {
    var kind = _ref.kind,
        isDisabled = _ref.isDisabled,
        suffixIcon = _ref.suffixIcon,
        shouldOpenNewTab = _ref.shouldOpenNewTab;

    if (kind === types.LINK && shouldOpenNewTab && suffixIcon) {
      return /*#__PURE__*/_react["default"].createElement(sc.LinkButtonIcon, {
        isDisabled: isDisabled,
        kind: types.LINK,
        isSuffixIcon: true
      }, suffixIcon);
    }

    return null;
  }

  return /*#__PURE__*/_react["default"].createElement(sc.LinkButton, (0, _extends2["default"])({
    "aria-disabled": isDisabled,
    "aria-label": a11yText,
    href: !isDisabled ? href : null,
    isDisabled: isDisabled,
    kind: kind,
    size: size
  }, shouldOpenNewTab ? shouldOpenNewTabProps : {}, moreProps, {
    as: isDisabled ? "span" : "a",
    ref: ref
  }), icon ? /*#__PURE__*/_react["default"].createElement(_Button.ButtonIcon, {
    isDisabled: isDisabled
  }, icon) : null, children, renderSuffix(props));
});

Link.types = {
  kind: constants.kind,
  size: constants.defaultSize
};
var propTypes = {
  /** Descriptive a11y text for assistive technologies. By default, text from children node will be used. */
  a11yText: _propTypes["default"].string,

  /** Body content of the button. */
  children: _propTypes["default"].node.isRequired,

  /** Url for the link. */
  href: _propTypes["default"].string.isRequired,

  /** An icon to be included to the left of children content. */
  icon: _propTypes["default"].node,

  /** If the button is disabled. */
  isDisabled: _propTypes["default"].bool,

  /** The visual style of the button. */
  kind: _propTypes["default"].oneOf([Link.types.kind.DEFAULT, Link.types.kind.PRIMARY, Link.types.kind.SECONDARY, Link.types.kind.DESTRUCTIVE, Link.types.kind.FLAT, Link.types.kind.MINOR, Link.types.kind.LINK]),

  /** Size of the button (font size, min-height, padding, etc). */
  size: _propTypes["default"].oneOf([Link.types.size.SMALL, Link.types.size.MEDIUM, Link.types.size.LARGE]),

  /** Whether the link should open a new tab. */
  shouldOpenNewTab: _propTypes["default"].bool,

  /** Size of the button (font size, min-height, padding, etc). */
  suffixIcon: _propTypes["default"].node
};
var defaultProps = {
  a11yText: null,
  icon: null,
  isDisabled: false,
  kind: Link.types.kind.LINK,
  shouldOpenNewTab: false,
  size: Link.types.size.MEDIUM,
  suffixIcon: /*#__PURE__*/_react["default"].createElement(_NewTab["default"], null)
};
Link.displayName = "Button.Link";
Link.propTypes = propTypes;
Link.defaultProps = defaultProps;
var _default = Link;
exports["default"] = _default;
//# sourceMappingURL=Link.js.map